interface PrintContentOptions {
  className: string;
  pageWidth?: number;
  contentWidth?: number;
}

export function printElement({
  className,
  pageWidth = 680,
  contentWidth = 1200,
}: PrintContentOptions): void {
  const scale = contentWidth > pageWidth ? pageWidth / contentWidth : 1;

  const style = document.createElement('style');
  style.textContent = `
    @media print {
      @page { size: auto; margin: 16px; }
      body { margin: 0; }
      html, body {
        height: auto;
        overflow: visible;
      }
      body * { visibility: hidden; }
      .${className}, .${className} * { visibility: visible; }
      .${className} {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: auto;
        overflow: visible;
        zoom: ${scale};
      }
      .${className} button { display: none !important; }
    }
  `;
  document.head.appendChild(style);
  window.print();
  document.head.removeChild(style);
}
